export default __webpack_public_path__ + "static/caseStudy1-uk-7f64e1afc83a27742548f65ec908b7f7.webp";